import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Account } from '../models/account.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class AccountsService {
  apiUrl: string;

  constructor(private http: HttpClient) { 
    this.apiUrl = environment.apiUris.identitiesApiUri;
  }

  getAccount(id: string) : Observable<Account> {
    return this.http.get<Account>(`${this.apiUrl}/Accounts/${id}`);
  }
}
